import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { readOnly } from '../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-bank-account-tabs',
    templateUrl: './bank-account-tabs.component.html',
    styleUrls: ['./bank-account-tabs.component.scss'],
    standalone: false
})
export class BankAccountTabsComponent implements OnInit, AfterViewInit {

  isViewInitialized = false;
  navLinks = [];
  data: any;

  constructor(
    private route: ActivatedRoute,
    private userPermissionService: UserPermissionService,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe(this.dataInit.bind(this));
  }

  ngOnInit() {
    this.navLinks = [{ path: 'details', label: 'DETAILS' }];

    if (this.route.snapshot.params.bankAccountId !== 'new') {
      this.navLinks.push({ path: 'audit', label: 'AUDIT TRAIL' });
    this.userPermissionService.granted([readOnly('servicing-synced-transaction')])
      .pipe(untilDestroyed(this))
      .subscribe(res => {
          if (res)
            this.navLinks.push({ path: 'transactions', label: 'TRANSACTIONS', query: { active: true } });
        });
    }
  }

    ngAfterViewInit() {
    this.isViewInitialized = true;
    this.changeDetector.detectChanges();
  }

  private dataInit(data: any) {
    this.data = data;

    if (this.data.appBar.closeAction.includes('company'))
      this.data.appBar.closeAction = `company/${this.route.snapshot.params.id}/banks`;
    else if (this.data.appBar.closeAction.includes('application'))
      this.data.appBar.closeAction = `application/${this.route.snapshot.params.id}/bank-accounts`;
    else if (this.data.appBar.closeAction.includes('account')) {
      const uniqueId = this.route.snapshot.params.uniqueId || this.route.snapshot.queryParams.uniqueId;
      this.data.appBar.closeAction = uniqueId
        ? `account/sf/${uniqueId}/bank-account`
        : `account/${this.route.snapshot.params.id}/bank-account`;
    }
  }
}
